

const redRes1=(state={},action)=>{
    switch(action.type)
    {
        case 'response1':
            if(action.payload != undefined){
                return action.payload;
            }
            else{
                return null
            }

        default:
            return state
    }
}
export default redRes1